import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Ship, ShieldCheck, GitCompareArrows, Calculator } from "lucide-react";
import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate(user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
  }, [user, loading, navigate]);

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Layout noFooter>
      <div className="min-h-[calc(100vh-4rem)] grid lg:grid-cols-2">
        <div className="hidden lg:flex flex-col justify-between bg-navy text-white p-12 relative overflow-hidden">
          <div className="absolute inset-0 hero-grid-fade opacity-40" />
          <div className="relative flex items-center gap-2.5">
            <div className="h-9 w-9 bg-cyan flex items-center justify-center rounded-sm"><Ship className="h-5 w-5 text-navy" /></div>
            <span className="font-heading font-extrabold text-lg">VK Forwarders</span>
          </div>
          <div className="relative">
            <h2 className="font-heading font-extrabold text-4xl leading-tight">Your freight rates, saved and organised.</h2>
            <p className="text-white/60 mt-4">Log in to save favourite routes, store quotations and track your shipment enquiries.</p>
            <div className="mt-8 space-y-4">
              {[
                { icon: GitCompareArrows, t: "Compare & save routes" },
                { icon: Calculator, t: "Store quotations & estimates" },
                { icon: ShieldCheck, t: "Track enquiry status" },
              ].map((x) => (
                <div key={x.t} className="flex items-center gap-3 text-white/80"><x.icon className="h-5 w-5 text-signal" /><span>{x.t}</span></div>
              ))}
            </div>
          </div>
          <div className="relative font-mono-data text-xs text-white/40">Planning Logistics · Moving Cargo · Delivering Trust</div>
        </div>

        <div className="flex items-center justify-center p-8">
          <div className="w-full max-w-sm">
            <h1 className="font-heading font-extrabold text-3xl text-navy">Customer Login</h1>
            <p className="text-muted-foreground mt-2">Sign in securely with your Google account to access your dashboard.</p>
            <Button onClick={handleLogin} className="w-full mt-8 h-12 bg-navy hover:bg-navy/90 text-white rounded-sm" data-testid="google-login-btn">
              <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24"><path fill="#fff" d="M12 11v2.8h4c-.2 1-1.3 3-4 3-2.4 0-4.3-2-4.3-4.4S9.6 8 12 8c1.4 0 2.3.6 2.8 1.1l1.9-1.8C15.5 6.2 13.9 5.5 12 5.5 8.4 5.5 5.5 8.4 5.5 12s2.9 6.5 6.5 6.5c3.7 0 6.2-2.6 6.2-6.3 0-.4 0-.7-.1-1H12z"/></svg>
              Continue with Google
            </Button>
            <p className="text-xs text-muted-foreground mt-6 text-center">By continuing you agree that rates shown are indicative and subject to final confirmation at booking.</p>
          </div>
        </div>
      </div>
    </Layout>
  );
}
